module.exports = __webpack_public_path__ + "static/media/wmsui32_2223.0d36006a.ico";